'use client'

import { useTranslations } from '@/lib/next-shim'

import { useConsultationWaitingGate } from '../model/useConsultationWaitingGate'
import { PatientWaitingRoom } from './PatientWaitingRoom'

export function ConsultationWaitingPage() {
  const t = useTranslations('common')
  const gate = useConsultationWaitingGate()

  switch (gate.status) {
    case 'loading':
    case 'notReady':
      return <div className="p-10 text-center">{t('loading')}</div>
    case 'profileError':
      return (
        <div className="p-10 text-center space-y-4">
          <p className="text-gray-700">{t('profileCheckFailed')}</p>
          <button
            type="button"
            onClick={gate.retry}
            className="inline-flex items-center px-4 py-2 rounded-md text-sm font-medium text-white bg-primary-600 hover:bg-primary-700"
          >
            {t('tryAgain')}
          </button>
        </div>
      )
    case 'consultationError':
      return <div className="p-10 text-center">{t('failedToLoadConsultationDetails')}</div>
    case 'notFound':
      return null
    case 'ready':
      return <PatientWaitingRoom consultationId={gate.consultationId} initialConsultation={gate.consultation} />
  }
}
